import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('ProductTypeReference', httpService);
  }

  getForCustomerOrder(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/CustomerOrder`);
  }
}
